import { render, staticRenderFns } from "./OAuth2Login.vue?vue&type=template&id=11c557b0&scoped=true&"
import script from "./OAuth2Login.vue?vue&type=script&lang=js&"
export * from "./OAuth2Login.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c557b0",
  null
  
)

export default component.exports